<template>
  <el-container style="height: calc(100vh - 0px); border: 1px solid #eee;">
    <el-header style="display: flex; justify-content: space-between; height: 49px; align-items: center;">
      <div class="ft16" style="margin-left: 7px; margin-top: 6px;display: flex;">
        <img src="../images/LOGO.png" alt="" srcset="" style="width: 100px;">
      </div>

      <div class="dl_at" style="height: 20px;">

        <el-dropdown @command="outLoginEvt" class="asds" style="height: 30px;line-height: 30px;">
          <span class="el-dropdown-link">
            <span class="mr5 ft12">{{ username }}</span>
            <img style="width: 13px; height: 13px; margin-left: 5px" src="../images/bottom.png" alt=""
                 class="el-dropdown-link"/>
          </span>
          <el-dropdown-menu slot="dropdown" style="top: 20px;">
            <el-dropdown-item command="1">退出登陆</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-container>
        <el-aside width="170px" style="border-right: 1px solid #d9d9d9;" v-show="userRole">
          <el-menu
              :default-active="activeIndex"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
          >
            <menu-item
                v-for="menu in filteredMenuList"
                :key="menu.index"
                :item="menu"
                :user-role="userRole"
                :img_num="img_num"
                @menu-click="handleMenuClick"
            />
          </el-menu>
        </el-aside>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import {StatusApi} from "../api/home/home.js";
import MenuItem from '@/components/Menu.vue';

export default {
  name: 'GlobalDrawer',
  components: {MenuItem},
  props: {
    title: {
      type: String,
      default: '惟妙科技ERP'
    },
    avatar: {
      type: String,
      default: '../../images/1.jpg'
    },
    activeIndex: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      localActiveIndex: this.activeIndex,// 通过 prop 初始化一个组件内部的数据
      username: null,
      selectedColor: 'white',
      isDaytime: true,
      userRole: '',
      token_na: null,
      img_num: null,
      menuList: [
        {
          index: '0',
          title: '官网新版本后台',
          role: [6], // 仅角色6可见
          isExternal: true, // 标记为外部链接
          href: () => `https://www.vimiuvr.com/login?vm_token=${this.token_na}` // 动态拼接链接
        },
        {
          index: '1',
          title: '项目管理',
          role: [3, 4, 5, 6, 8] // 支持多个角色可见
        },
        {
          index: '2',
          title: '作品管理',
          role: [3, 4, 5, 6, 8]
        },
        {
          index: '3',
          title: '员工管理',
          role: [3, 4, 5, 6, 8]
        },
        {
          index: '4',
          title: '工资管理',
          role: [6, 8],
          children: [ // 子菜单配置
            {index: '4-1', title: '员工每月工资表', role: [6, 8]},
            {index: '4-2', title: '员工年度工资表', role: [6]},
            {index: '4-3', title: '部门年度成本表', role: [6, 8]},
            {index: '4-4', title: '每月部门产值成本', role: [6]}
          ]
        },
        {
          index: '5',
          title: '客户管理',
          role: [3, 6]
        },
        {
          index: '6',
          title: '支出管理',
          role: [6]
        },
        {
          index: '7',
          title: '收入管理',
          role: [3, 6]
        },
        {
          index: '8',
          title: '银行管理',
          role: [6],
          children: [
            {index: '8-1', title: '账户明细'},
            {index: '8-2', title: '转移明细'},
            {index: '8-3', title: '账户列表'},
            {index: '8-4', title: '货币管理'}
          ]
        },
        {
          index: '9',
          title: '基础资料',
          role: [6],
          children: [
            {
              index: '9-1',
              title: '公司相关',
              children: [
                {index: '9-1-1', title: '收入类别'},
                {index: '9-1-2', title: '结算部门'}
              ]
            },
            {
              index: '9-2',
              title: '项目相关',
              children: [
                {index: '9-2-1', title: '客户类型'},
                {index: '9-2-2', title: '所属公司'},
                {index: '9-2-3', title: '所属部门'}
              ]
            }
          ]
        },
        {
          index: '10',
          title: '运营情况',
          role: [6]
        },
        {
          index: '11',
          title: '业务报表',
          role: [3, 6]
        },
        {
          index: '12',
          title: '用户帐号',
          role: [6],
          children: [
            {index: '12-1', title: '帐号管理'},
            {index: '12-2', title: '理论价格设置'}
          ]
        },
        {
          index: '13',
          title: '评图',
          role: [3, 4, 5, 6, 8],
          hasBadge: true // 标记需要显示徽章
        }
      ]
    };
  },
  created() {
    this.username = localStorage.getItem("name");
    const storedColor = localStorage.getItem('selectedColor') || 'white';
    this.changeBackgroundColor(storedColor);

    StatusApi({}).then((res => {
      this.userRole = res.user.role
      this.img_num = res.img_num
      localStorage.setItem("role", res.user.role);
    }))
    this.token_na = localStorage.getItem('token')
  },
  mounted() {
  },

  methods: {
    changeBackgroundColor(color) {
      this.selectedColor = color;
      const body = document.body;
      localStorage.setItem('selectedColor', color);
      if (color === 'black') {
        body.style.backgroundColor = '#000';
        body.style.filter = 'invert(1)';
      } else if (color === 'white') {
        body.style.backgroundColor = '#fff';
        body.style.filter = 'invert(0)';
      } else if (color === 'natural') {
        const now = new Date();
        const hours = now.getUTCHours() + 8; // 北京时间比UTC时间晚8小时
        this.isDaytime = hours >= 6 && hours < 18;
        if (this.isDaytime) {
          body.style.backgroundColor = '#fff';
          body.style.filter = 'invert(0)';
        } else {
          body.style.backgroundColor = '#000';
          body.style.filter = 'invert(1)';
        }
      }
    },
    handleOpen() {
      // 处理抽屉打开的逻辑
    },
    handleClose() {
      // 处理抽屉关闭的逻辑
    },
    handleMenuClick(index) {
      this.localActiveIndex = index; // 更新当前选中的菜单项的值
      // 根据菜单项的值进行路由跳转
      switch (index) {
        case '1':
          this.$router.push('/');
          break;
        case '2':
          this.$router.push('/Work_management');
          break;
        case '3':
          this.$router.push('/Staff_management');
          break;
        case '4-1':
          this.$router.push('/Monthly_salary');
          break;
        case '4-2':
          this.$router.push('/Annual_salary');
          break;
        case '4-3':
          this.$router.push('/Annual_department');
          break;
        case '4-4':
          this.$router.push('/Monthly_department');
          break;
        case '5':
          this.$router.push('/Customer_management');
          break;
        case '6':
          this.$router.push('/Expenditure_management');
          break;
        case '7':
          this.$router.push('/Revenue_management');
          break;
        case '8-1':
          this.$router.push('/Account_details');
          break;
        case '8-2':
          this.$router.push('/Transfer_details');
          break;
        case '8-3':
          this.$router.push('/Account_list');
          break;
        case '8-4':
          this.$router.push('/monetary_management');
          break;
        case '9-1-1':
          this.$router.push('/Income_category');
          break;
        case '9-1-2':
          this.$router.push('/Settlement_department');
          break;
        case '9-2-1':
          this.$router.push('/Affiliated_company');
          break;
        case '9-2-2':
          this.$router.push('/Customer_type');
          break;
        case '9-2-3':
          this.$router.push('/Department');
          break;
        case '10':
          this.$router.push('/Operations');
          break;
        case '11':
          this.$router.push('/Business_report');
          break;
        case '12-1':
          this.$router.push('/Account_management');
          break;
        case '12-2':
          this.$router.push('/theoretical_price');
          break;
        case '13':
          this.$router.push('/Design_comment');
          window.location.reload(true)
          break;
        default:
      }
    },
    //退出登录清除token
    outLoginEvt(e) {
      localStorage.clear();
      if (e == 1) {
        localStorage.removeItem("token");
        window.location.href = 'https://www.vimiu3d.com/manage/login/login';
      }
    },
  },
  computed: {
    // 过滤出当前角色可见的菜单（核心权限逻辑）
    filteredMenuList() {
      return this.menuList.filter(menu => {
        return menu.role ? menu.role.includes(this.userRole) : true;
      });
    }
  },
}
</script>

<style scoped lang="less">
/* 添加你的样式 */
.el-header {
  background-color: #fff;
  color: #333;
  line-height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0px;
  color: #333;
  line-height: 60px;
  z-index: 100;
  border-bottom: 1px solid #d1d1d1;
  /* 使Header在其他内容之上 */
}

/* 固定左侧的项目管理列表 */
.el-aside {
  position: fixed;
  top: 50px;
  /* 顶部Header的高度，根据你的实际Header高度调整 */
  left: 0;
  width: 155px;
  height: 100%;
  /* 使其充满整个可视区域的高度 */
  z-index: 99;
  /* 使其在正文内容之上 */
}

/deep/ .el-menu-item.is-active {
  background: #ecf5ff;
}


/deep/ .el-menu-item:nth-child(1) {
  height: 45px;
  line-height: 45px;
  color: #292929;
  font-size: 14px;
  padding-left: 20px;
  text-align: left;
}

/deep/ .el-menu-item:nth-child(2) {
  height: 44px;
  line-height: 45px;
  color: #292929;
  font-size: 14px;
  text-align: left;
}


/deep/ .el-menu-item {
  height: 44px;
  line-height: 45px;
  color: #292929;
  font-size: 14px;
  padding-left: 30px !important;
  text-align: left;
}

/deep/ .el-menu-item-group__title {
  height: 44px;
  line-height: 45px;
  color: #292929;
  font-size: 14px;
  text-align: left;
}

/deep/ .el-popper {
  top: 10px !important;
}

#colorChanger span {
  cursor: pointer;
}

/deep/ .el-menu-item-group__title {
  padding: 0px 0 7px 0px !important;
}

/deep/ .el-submenu .el-menu-item {
  min-width: 170px;
}

/deep/ .el-submenu__title {
  padding-right: 75px !important;
  height: 39px !important;
  line-height: 39px !important;
  list-style: none;
}

.max_one {
  padding-left: 40px !important;
  font-size: 14px !important;
}

.max_two {
  padding-left: 60px !important;
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalHeader.vue